import { useQuery } from '@tanstack/react-query';
import { getAnswerFeatures } from '../../../services/monitor/features/MonitorFeaturesService';
import { GET_ANSWER_FEATURES } from '../../../query/monitor/features/keys';
import { AnswerFeaturesResponse } from '../../../../models/monitor/ResponseFeatures';

/**
 * Lazy per-answer heavy payloads (ads/products/locations) — fetched only for expanded answers
 * that report non-zero counts in responseMetadata. Cached per monitorDataId.
 */
export const useGetAnswerFeatures = (monitorDataId: number | null) => {
  const query = useQuery<AnswerFeaturesResponse>({
    queryKey: [GET_ANSWER_FEATURES, monitorDataId],
    queryFn: () => {
      if (!monitorDataId) {
        throw new Error('monitorDataId is required');
      }
      return getAnswerFeatures(monitorDataId);
    },
    staleTime: 1000 * 60 * 30,
    gcTime: 1000 * 60 * 30,
    refetchOnWindowFocus: false,
    enabled: !!monitorDataId,
  });

  return {
    features: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
  };
};
